export default "__VITE_ASSET__mgzIwYXR__"